import { useSelector } from 'react-redux';
import { NotificationHubState } from '../types/notificationHub.types';
import { SharedStoreState } from '../types';

export const useSelectNotificationHub = (): NotificationHubState =>
	useSelector<SharedStoreState, NotificationHubState>(
		state => state.notificationHub,
	);
